module.exports = require('vector2d').ObjectVector;



// WEBPACK FOOTER //
// ./core/Vector.js